import React, { Component, useState, useRef, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "./../component/Header";
import Footer from "./../component/Footer";
import ProductCardSkeleton from "./../component/ProductCardSkeleton";
import HeadingSkeleton from "./../component/HeadingSkeleton";
import $ from "jquery";
import { API_BASE_URL, IMAGE_URL } from "../utils/app_url";
import { useLanguage } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";
const VideoImg = require("./../assets/img/videos.png");
const playIcon = require("./../assets/img/play-icon.svg").default;
const prevIcon = require("./../assets/img/chev-left.svg").default;
const nextIcon = require("./../assets/img/chev-right.svg").default;

const Videos = () => {
  const { user } = useAuth();
  const { selectedLanguage, langJson } = useLanguage();
  const { slugName } = useParams();

  const [eventList, setEventList] = useState();
  const [loading, setLoading] = useState(true);

  const fetchEvents = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}frontend/videos`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // Authorization: `Bearer ${user.authorisation.token}`,
        },
      });
      const responseData = await response.json();
      if (responseData.res === true) {
        setEventList(responseData.data.data);
      } else {
      }
    } catch (error) {
      console.error("Error during Sign UP:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  return (
    <div>
      <Header />
      <style>{`body { background: #FFF; }`}</style>

      <div className="fullContainer">
        <div className="categoryDiv productSliderMain topNew tradePrdts">

          <div className="hdnSec">
            {loading ? (
              <HeadingSkeleton width="200px" height="28px" />
            ) : (
              <h2 className="storeTabHdn">{langJson?.videos}</h2>
            )}
          </div>
          <ul className="eventList videosList products eventListNew products-5-col">
            {loading ? (
              Array.from({ length: 5 }).map((_, index) => (
                <ProductCardSkeleton key={index} />
              ))
            ) : eventList?.map((item, index) => (
              <li key={index}>
                <Link to={`/video/${item?.video_id}`} target="_blank">
                  <div className="videoHldr">
                    <img src={item?.image} alt="" />
                    <img src={playIcon} alt="" className="playBtn" />
                  </div>
                  <h3>{item?.title}</h3>
                </Link>
              </li>
            ))}
          </ul>

        </div>

        {/* <div className="paginationDiv">
          <ul>
            <li>
              <Link to="">
                <img src={prevIcon} alt="" />
              </Link>
            </li>
            <li>
              <Link to="">1</Link>
            </li>
            <li>
              <Link to="">2</Link>
            </li>
            <li>
              <Link to="">3</Link>
            </li>
            <li>
              <Link to="">4</Link>
            </li>
            <li>
              <Link to="">5</Link>
            </li>
            <li>
              <Link to="">
                <img src={nextIcon} alt="" />
              </Link>
            </li>
          </ul>
        </div> */}
      </div>

      <Footer />
    </div>
  );
};

export default Videos;
